import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-y",
  "use": "icon-arrow-y-usage",
  "viewBox": "0 0 20 10",
  "content": "<symbol viewBox=\"0 0 20 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-y\">\n<path d=\"M0 0H20L11.4286 10H8.57143L0 0Z\" fill=\"url(#icon-arrow-y_paint0_linear_855_8533)\" />\n<defs>\n<linearGradient id=\"icon-arrow-y_paint0_linear_855_8533\" x1=\"10\" y1=\"0\" x2=\"10\" y2=\"10\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#FFD175\" stop-opacity=\"0\" />\n<stop offset=\"1\" stop-color=\"#FFB013\" stop-opacity=\"0.7\" />\n</linearGradient>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol